import React, { useContext } from 'react';
import { IoNotifications } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import placeholderimg from '../../Assets/img/logos/place_profile.png';
import { AppContext } from '../../appContext';
import { CgProfile } from "react-icons/cg";
import { Badge, IconButton } from '@mui/material';
function UserProfile({ imgUrl, mailId, NotificationBlock, width }) {
  const { chatCount } = useContext(AppContext);
  return (
    <div className="flex justify-between items-center px-2 w-full gap-3">
      <Link to={'/profile'}>
        <div className="flex items-center gap-3 ">
          {
            imgUrl ?
              <div className="w-12 h-12 bg-blue-400 rounded-full bg-avatar">
                <img
                  src={imgUrl ? `${process.env.REACT_APP_API_URL}/${imgUrl}` : placeholderimg}
                  className="block object-cover rounded-full w-full h-full"
                />
              </div> :
              <div className="size-12 bg-white flex items-center justify-center rounded-full shadow-sm border ">
                <CgProfile size={35} className="text-lightcolor" />
              </div>
          }

          <div >
            <p className="smallerText  text-gray-400 mb-[3px]">Welcome,</p>
            <p className={`headingText !font-medium text-coalBlack w-full ${width ? `max-w-[60vw]` : 'max-w-[80vw]'} md:max-w-[30vw] lg:max-w-[30vw] whitespace-nowrap truncate overflow-hidden sm:max-w-max`}>
              {mailId}
            </p>
          </div>
        </div>
      </Link>
      <div className={`relative ${NotificationBlock ? 'block' : 'hidden'}`}>
        <Link to={'/notification'} className='relative block'>
          <IconButton aria-label="notification">
            {
              chatCount > 0 && !isNaN(chatCount) ? (
                <Badge
                  badgeContent={chatCount}
                  slotProps={{ badge: { className: 'bg-accent text-white !font-bold' } }}
                >
                  <IoNotifications className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer' />
                </Badge>
              ) : (
                <IoNotifications className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer' />
              )
            }
          </IconButton>
        </Link>

      </div>
    </div>
  );
}

UserProfile.defaultProps = {
  mailId: 'Example@gmail.com',
  NotificationBlock: false,
};
export default UserProfile;
